import React, { ReactElement } from 'react';

import { configManager } from 'utils/configuration';

import styles from './SSLIcon.module.scss';

function SSLIcon(): ReactElement {
  const getConfig = configManager.getInstance().get;

  const SSLIconUrl = `${getConfig('CDN_URL')}${getConfig(
    'BUCKET_PATH'
  )}${getConfig('SSL_ICON_URL')}`;

  return (
    <div className={styles.sslIconWrapper} data-testid="SSLIconWrapper">
      <img
        className={styles.sslIcon}
        src={SSLIconUrl}
        alt="SSL Secured"
        data-testid="SSLIconImage"
      />
    </div>
  );
}

export default SSLIcon;
